import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { TableColumn } from "./TableColumn";

import { useLeaveHistory } from "@hooks/HRM/leave/useLeaveHistory";

import { TablePagination } from "@helpers/tablePagination";

interface LeaveHistoryProps {
  employeeId: string | number;
}

export const LeaveHistoryTable = ({ employeeId }: LeaveHistoryProps) => {
  const { t } = useTranslation();
  const { leaveHistoryList, pagination, handleQuery } =
    useLeaveHistory(employeeId);

  return (
    <div className="mt-10">
      <Table
        columns={TableColumn(t) as any}
        rows={leaveHistoryList}
        header={{
          title: t("LEAVE_LIST.TABLE.HEADER"),
          badge: {
            label: `${pagination?.total || 0}`,
            size: "sm",
            type: "primary",
          },
        }}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};
